import { API_URL } from 'src/config'
import * as Rest from 'src/constants/rest'
import { Expedient } from 'src/interfaces'
import { ExpedientDataFromLexon } from 'src/interfaces/EscritosLegales'
import http from 'src/utils/Http'

export interface GetExpedientsResponse {
  results: Expedient[]
  page: number
  total: number
}

export function getExpedients(
  companyId: string,
  q = '',
  itemsPerPage = 5,
  page = 1
): Promise<GetExpedientsResponse> {
  return http
    .get({
      url: Rest.EXPEDIENTS,
      token: true,
      params: {
        companyId,
        q,
        itemsPerPage,
        page
      }
    })
    .then(res => ({
      results: res.data,
      page: res.pagination.numPage,
      total: res.pagination.totalRecs
    }))
}

export function getExpedientData(
  expedientId: number,
  companyId: number
): Promise<ExpedientDataFromLexon> {
  return http
    .get({
      url: `${API_URL}/lexon/expedientData/${expedientId}`,
      token: true,
      params: {
        companyId
      }
    })
    .then(res => res)
}
